import React, { Component } from "react";
import {
  Modal,
  Button,
  Form,
  Image,
  Tooltip,
  OverlayTrigger
} from "react-bootstrap";
import connect from "react-redux/es/connect/connect";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import ProjectSearchSorting from "./ProjectSearchSorting";
import { LoaderPage } from "../../../component/Loader";
import LoaderTemplate from "../../../component/LoaderTemplate";
import { FilterLoader } from "../../../component/LoadersTemplate";
import FilterComponent from "../../FilterComponent";
import {
  getLocalstorage,
  isValidArray,
  transformProjectListPayload,
  setLocalstorage
} from "../../../helper";
import { get } from "lodash";
import { PROJECT_AWARDED_BY, STATUS } from "../../../constant";
import LoadListOnScroll from "../../../component/loadListOnScroll";
import { ToggleBtn } from "../../togglebtn";
import IconFilter from "../../../assets/filter.svg";
import { getProjectList } from "../../../services/apiServices";
import request from "../../../services/requestService";
import PermissionHOC from "../../PermissionHOC";
import { ProjectListHoc } from "../../projectList/projectListHoc";
import SelectProjectWithLoader from "./SelectProjectWithLoader";
import ProjectQuickFilter from "../../FilterComponent/ProjectQuickFilter";
import SelectIssue from "../SelectIssue";
import DisplayByPermission from "../../../component/DisplayByPermission";
import TooltipCustom from "../TooltipCustom";
import AgendaStateProjectQF from "../../FilterComponent/AgendaStateProjectQF";

const defaultListParams = {
  limit: 50,
  offset: 0,
  sortBy: "CREATED_DATE",
  sortOrder: "DESC",
  isAgendaProjectList: true
};

const sortByArr = [
  {
    sortBy: "PROJECT_COST",
    sortOrder: "DESC",
    name: (
      <span>
        by <b>High</b> budget
      </span>
    ),
    active: "high"
  },
  {
    sortBy: "PROJECT_COST",
    sortOrder: "ASC",
    name: (
      <span>
        by <b>Low</b> budget
      </span>
    ),
    active: "low"
  },
  {
    sortBy: "CREATED_DATE",
    sortOrder: "DESC",
    name: (
      <span>
        by <b>Latest</b> created
      </span>
    ),
    active: "latest"
  },
  {
    sortBy: "CREATED_DATE",
    sortOrder: "ASC",
    name: (
      <span>
        by <b>Old</b> created
      </span>
    ),
    active: "old"
  }
];

export class SelectProject extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loadedProjects: {},
      show: false,
      disableAddIssueModal: true,
      isAddIssueModalVisible: false,
      addInAgendaDisable: true,
      selectedIssues: [],
      loadedIssuesListBy: {},
      projectListApiStatus: STATUS.LOADING,
      isAllDataLoaded: false,
      filterArrayName: [],
      projectsList: [],
      projectListOnSelection: [],
      newProjectList: [],
      activeProjects: [],
      selectedProjectIds: [],
      selectedFilter: {},
      projectDTO: {},
      offset: 0,
      minRange: 0,
      bubbleFilters: [],
      //projectAwardedBy: getLocalstorage("userSponsoredScheme"),
      projectAwardedBy: false,
      staticfilterdata: [],
      state_static_filter_data: [],
      static_payload_for_state: {
        limit: 50,
        offset: 0,
        sortBy: "CREATED_DATE",
        sortOrder: "DESC",
        isAgendaProjectList: true,
        groupCategory: "STATE",
        projectsSelectedInAgenda: []
      },

      state_static_filter_data: [],
      filtersData: [],
      //listDTO:[],
      projectListParams: {
        ...defaultListParams,
        groupCategory: "CENTRAL",
        projectCost: [],
        delayedProject: [],
        costOverRun: []
      },
      static_payload: {
        offset: 0,
        limit: 10,
        groupCategory: "CENTRAL",
        isAgendaProjectList: true,
        projectCost: [],
        delayedProject: [],
        costOverRun: []
      },
      static_payload1: {
        offset: 0,
        limit: 50,
        groupCategory: "CENTRAL",
        isAgendaProjectList: true,
        projectCost: [],
        delayedProject: [],
        costOverRun: []
      },
      static_payload50_state: {
        offset: 0,
        limit: 50,
        groupCategory: "STATE",
        isAgendaProjectList: true,
        projectCost: [],
        delayedProject: [],
        costOverRun: []
      },
      quickfilterdatanew: [
        "projectFlags",
        "projectTags",
        "projectStage",
        "sponsoringMinistry",
        "projectLocation",
        "projectImplementationMode",
        "projectZones"
      ],
      Monitoringflagcurrent: [],
      ProjectStatuscurrent: [],
      ProjectStagecurrent: [],
      ProjectSponsoringMinistrycurrent: [],
      ProjectLocationcurrent: [],
      ImplementationModecurrent: [],
      Projectzonecurrent: [],
      agendaissuestagesdata: true,
      Monitoringflag_State: [],
      ProjectStatus_State: [],
      ProjectStage_State: [],
      ProjectSponsoringDepartment_State: [],
      ImplementationMode_State: [],
      ProjectCost_State: [],
      ProjectDistrict_State: [],
      StateQuickFilters: [],
      quickfilterdata_state: [
        "projectFlags",
        "projectTags",
        "projectStage",
        "sponsoringDepartment",
        "districtProjectLocation",
        "projectImplementationMode",
        "projectCost"
      ]
    };
  }

  componentDidMount = async () => {
    //Static issue Filter API Call Starts
    const { selectedProjects } = this.props;
    const response = await request(getProjectList(this.state.static_payload));
    this.setState({ staticfilterdata: response.data.data.filters });
    const state_response = await request(
      getProjectList(this.state.static_payload_for_state)
    );

    this.setState({
      state_static_filter_data: state_response.data.data.filters
    });
    if (isValidArray(selectedProjects) && selectedProjects.length > 0) {
      this.setState({
        disableAddIssueModal: false
      });
    } else {
      this.setState({ disableAddIssueModal: true });
    }
    this.getProjectListData({
      ...{
        groupCategory: this.getGroupCategory()
      }
    });
    //Static issue Filter API Call End
  };

  handleFilterChange = async (updatedFilters, filterName) => {
    if (filterName == undefined) {
      const newData = [];
      newData.push(...updatedFilters);
      // const flattenedArray = newData.map(item => {
      //   // Check if the first element of the object is an object
      //   if (typeof item['0'] === 'object') {
      //     // Merge the properties of the first element with the rest of the object
      //     return {
      //       ...item['0'],
      //       ...item
      //     };
      //   } else {
      //     // Return the original object if the first element is not an object
      //     return item;
      //   }
      // });

      // console.log(flattenedArray);
      this.setState({ bubbleFilters: newData }, () => {
        console.log(this.state.bubbleFilters);
      });
    } else {
      const updatedData = updatedFilters.map(obj => ({
        ...obj,
        filterName: filterName
      }));
      const newData = [...this.state.bubbleFilters];
      newData.push(...updatedData);
      this.setState({ bubbleFilters: newData }, () => {
        //console.log(this.state.QuickFilters)
      });
    }

    // this.getProjectListData(
    //   transformProjectListPayload(this.state.static_payload)
    // );
  };

  getProjectListData = (params = {}) => {
    try {
      const {
        projectListParams,
        projectDTO,
        projectsList,
        loadedProjects
      } = this.state;
      const { selectedProjects } = this.props;
      let selectedProjectIdArr =
        (selectedProjects &&
          selectedProjects.length &&
          selectedProjects.map(item => item.id)) ||
        [];
      const currentParams = {
        ...projectListParams,
        ...params,
        projectsSelectedInAgenda: selectedProjectIdArr
        //selectedIssuesIdArr
      };
      this.setState(
        {
          projectListApiStatus: STATUS.LOADING,
          projectListParams: currentParams
        },
        async () => {
          const response = await request(getProjectList(currentParams));
          if (response) {
            const { status, data } = response;
            if (status) {
              // console.log("data", data.data);
              // console.log("loadedProjects", loadedProjects);
              const newData = data.data;
              // const { data } = data;
              // console.log("calculated", {
              //   ...loadedProjects,
              //   [currentParams.offset]: newData,
              // });
              this.setState({
                projectListApiStatus: STATUS.SUCCESS,
                isAllDataLoaded: !isValidArray(response.data.data.listDTO),
                //staticfilterdata: response.data.data.filters,
                filtersData: response.data.data.filters,
                projectsList: [...projectsList, ...response.data.data.listDTO],
                projectDTO: response.data.data,
                loadedProjects: {
                  ...loadedProjects,
                  [currentParams.offset]: newData
                }
              });
            } else {
              this.setState({
                projectListApiStatus: STATUS.ERROR,
                isAllDataLoaded: !isValidArray(response.data.data.listDTO)
              });
            }
          }
        }
      );
    } catch (e) {
      console.log("Error while fetching error", e);
    }
  };

  getGroupCategory = () => {
    return this.state.projectAwardedBy
      ? PROJECT_AWARDED_BY.STATE
      : PROJECT_AWARDED_BY.CENTRAL;
  };

  selectionHandler = idx => {
    let { loadedProjects, selectAll } = this.state;
    // make single array to loaded list
    let projectList = [];
    Object.keys(loadedProjects).forEach(key => {
      projectList = [
        ...projectList,
        ...get(loadedProjects[key], "listDTO", [])
      ];
    });

    //let { selectAll, projectsList } = this.state;
    let { selectedProjects } = this.props;
    // // make single array to loaded list
    //let projectList = projectsList;
    // let selectedArray = [];

    // /////////////////////////////////////////////////
    if (projectList[idx]) {
      projectList[idx]["isSelected"] = !projectList[idx]["isSelected"];
      if (selectAll) {
        !projectList[idx]["isSelected"] && (selectAll = false);
      }

      this.setState({
        selectAll,
        loadedProjects: {
          ...loadedProjects
        }
      });
    }
    const checkedProjects = this._getSelectedProjects();
    //console.log(checkedProjects);
    if (checkedProjects.length > 0) {
      this.setState({
        addInAgendaDisable: false
      });
    } else {
      this.setState({
        addInAgendaDisable: true
      });
    }
    if (selectedProjects.length == 0 && checkedProjects.length == 0) {
      this.setState({
        disableAddIssueModal: true
      });
    } else {
      this.setState({
        disableAddIssueModal: false
      });
    }
  };

  _getSelectedProjects = id => {
    const { loadedProjects } = this.state;
    let projectsList = [];
    Object.keys(loadedProjects).forEach(key => {
      projectsList = [
        ...projectsList,
        ...get(loadedProjects[key], "listDTO", [])
      ];
    });

    const activeProjects = [];
    for (let i = 0; i < projectsList.length; i++) {
      const currentProject = projectsList[i];
      if (id && currentProject.isSelected) {
        currentProject.isSelected = false;
        this.setState(prevState => ({
          projectsList: [...prevState.projectsList]
        }));
      } else if (currentProject.isSelected) {
        activeProjects.push(currentProject);
      }
    }

    this.setState({ projectListApiStatus: STATUS.SUCCESS });
    return activeProjects;
  };

  showAddIssueModal = (data, result) => {
    this.setState({
      isAddIssueModalVisible: true
      //result: result
    });
  };

  submitHandler = () => {
    const { activeProjects, selectedProjectIds } = this.state;
    const { selectedProjects } = this.props;

    let allActiveProjects = [];
    const checkedProjects = this._getSelectedProjects();
    allActiveProjects = [...checkedProjects, ...selectedProjects];
    //changes after merge start
    const uniqueActiveProjects = allActiveProjects.filter(
      (project, index, self) =>
        self.findIndex(p => p.id === project.id) === index
    );
    //changes after merge end
    this.setState({ activeProjects: uniqueActiveProjects });

    if (isValidArray(uniqueActiveProjects) && uniqueActiveProjects.length > 0) {
      this.showAddIssueModal();
    }
    // submitHandler();
  };

  toggleSelectAll = () => {
    const { selectAll, loadedProjects } = this.state;
    const { selectedProjects } = this.props;
    let projectsList = [];
    Object.keys(loadedProjects).forEach(key => {
      projectsList = [
        ...projectsList,
        ...get(loadedProjects[key], "listDTO", [])
      ];
    });

    projectsList.forEach(project => {
      project.isSelected = !selectAll;
    });

    const checkedProjects = this._getSelectedProjects();
    if (checkedProjects.length > 0) {
      this.setState({
        addInAgendaDisable: false
      });
    } else {
      this.setState({
        addInAgendaDisable: true
      });
    }

    if (selectedProjects.length == 0 && checkedProjects.length == 0) {
      this.setState({
        disableAddIssueModal: true
      });
    } else {
      this.setState({
        disableAddIssueModal: false
        // addInAgendaDisable: false
      });
    }
    this.setState({
      selectAll: !selectAll
    });
  };

  handleCheckbox = (filter, filterName) => {
    const filterData = this.postFilterData(filter, filterName);
    this.setState(
      {
        loadedProjects: {}
        //projectsList: [],
      },
      () => {
        this.getProjectListData({ ...filterData, offset: 0 });
      }
    );
  };
  handleCheckbox1 = (filter, filterName) => {
    if (filter.hasOwnProperty("filterName")) {
      const entries = Object.entries(filter);
      const lastEntry = entries.pop();
      delete filter[lastEntry[0]];
      //console.log(value)
    }
    const filterData = this.postFilterDatadelete(filter, filterName);
    this.setState(
      {
        loadedProjects: {}
        //projectsList: [],
      },
      () => {
        this.getProjectListData({ ...filterData, offset: 0 });
      }
    );
  };

  onLoadMore = async () => {
    const { isAllDataLoaded } = this.state;
    this.setState(
      {
        isAllDataLoaded: true
      },
      () => {
        const {
          projectListParams: { offset }
        } = this.state;
        this.getProjectListData({ offset: offset + 1 });
      }
    );
  };

  postFilterDatadelete = (value, filterName) => {
    //console.log(value);
    const targetObjectIndex = this.state.bubbleFilters.findIndex(
      item => item.displayName === value.displayName
    );

    if (targetObjectIndex !== -1) {
      this.state.bubbleFilters.splice(targetObjectIndex, 1);
    }
    let { projectListParams, filterArrayName } = this.state;
    let currentFilter = projectListParams[filterName];
    const filter = this.isFiltersAlreadyApplied(filterArrayName, value);

    this.setState({
      loadedProjects: {}
    });

    // to keep projectListParams seperate we are rendering filterArray name here
    if (filterName !== "projectIdFilter") {
      let newArr = [];
      if (!get(filter, "filter.displayName")) {
        newArr = [{ ...value, filterName }];
      } else {
        value.checked = false;
        filterArrayName.splice(get(filter, "index"), 1);
      }
      this.setState({
        filterArrayName: [...filterArrayName, ...newArr]
      });
    }
    switch (filterName) {
      // in this case value is object
      case "sponsoringState":
      case "sponsoringMinistry":
      case "sponsoringDepartment":
      case "districtStateDept":
      case "projectStage":
      case "recipientStateDepartment":
      case "projectProponent":
      case "bucket":
      case "milestone":
      case "bucketStatus":
      case "milestoneStatus":
      case "projectTags":
      case "projectSector":
      case "projectLocation":
      case "projectImplementationMode":
      case "recipientMinistry":
      case "projectFlags":
      case "projectZones":
      case "districtProjectLocation":
        currentFilter = currentFilter || [];
        let filter = currentFilter.find(val => val === value.key);
        !filter
          ? currentFilter.push(value.key)
          : (currentFilter = currentFilter.filter(val => val !== value.key));
        projectListParams = {
          ...projectListParams,
          [filterName]: currentFilter
        };
        //console.log(projectListParams)
        break;

      // In this case value is boolean
      case "pmg":
      case "pragatiReview":
        currentFilter = value.checked;
        !currentFilter && delete projectListParams[filterName];
        projectListParams = !currentFilter
          ? { ...projectListParams, ...defaultListParams }
          : { ...projectListParams, [filterName]: currentFilter };
        break;

      case "projectCost":
      case "delayedProject":
      case "costOverRun":
        currentFilter = currentFilter || [];
        const { key } = value || {};
        const from = key.split("-")[0];
        const to = key.split("-")[1];
        if (isValidArray(currentFilter)) {
          const keys = value.key.split("-");

          const index = currentFilter.indexOf(value => {
            const { key } = value;
            return key.from === from && key.to === to;
          });

          index
            ? currentFilter.splice(index, 1)
            : currentFilter.push({
                from: keys[0] === "null" ? null : keys[0],
                to: keys[1] === "null" ? null : keys[1]
              });
        } else {
          currentFilter.push({
            from: from === "null" ? null : from,
            to: to === "null" ? null : to
          });
        }
        !currentFilter && delete projectListParams[filterName];
        projectListParams = !currentFilter
          ? { ...projectListParams }
          : { ...projectListParams, [filterName]: currentFilter };
        break;

      default:
        break;
    }

    return { ...projectListParams, offset: 0 };
  };

  clearAll = () => {
    this.setState(
      {
        projectListParams: { ...defaultListParams },
        filterArrayName: [],
        bubbleFilters: []
      },
      () => {
        this.getProjectListData({
          groupCategory: this.getGroupCategory()
        });
      }
    );
    localStorage.setItem("ClearAll", JSON.stringify(true));
  };

  isFiltersAlreadyApplied = (filterArr, filter) => {
    let currentIndex = 0;
    const filterApplied = filterArr.find((value, index) => {
      currentIndex = index;
      return value.displayName === filter.displayName;
    });
    return { filter: filterApplied, index: currentIndex };
  };

  postFilterData = (value, filterName) => {
    if (value.checked) {
      const newValue1 = { ...value, filterName: filterName };
      const newItems1 = [...this.state.bubbleFilters];
      newItems1.push(newValue1);
      this.setState({ bubbleFilters: newItems1 }, () => {
        //console.log(this.state.bubbleFilters)
      });
    } else {
      const targetObjectIndex = this.state.bubbleFilters.findIndex(
        item => item.displayName === value.displayName
      );

      if (targetObjectIndex !== -1) {
        this.state.bubbleFilters.splice(targetObjectIndex, 1);
      }
    }
    if (value.hasOwnProperty("filterName")) {
      const entries = Object.entries(value);
      const lastEntry = entries.pop();
      delete value[lastEntry[0]];
      //console.log(value)
    }
    let { projectListParams, filterArrayName } = this.state;
    let currentFilter = projectListParams[filterName];
    const filter = this.isFiltersAlreadyApplied(filterArrayName, value);

    this.setState({
      loadedProjects: {}
    });

    // to keep projectListParams seperate we are rendering filterArray name here
    if (filterName !== "projectIdFilter") {
      let newArr = [];
      if (!get(filter, "filter.displayName")) {
        newArr = [{ ...value, filterName }];
      } else {
        value.checked = false;
        filterArrayName.splice(get(filter, "index"), 1);
      }
      this.setState({
        filterArrayName: [...filterArrayName, ...newArr]
      });
    }
    switch (filterName) {
      // in this case value is object
      case "sponsoringState":
      case "sponsoringMinistry":
      case "sponsoringDepartment":
      case "districtStateDept":
      case "projectStage":
      case "recipientStateDepartment":
      case "projectProponent":
      case "bucket":
      case "milestone":
      case "bucketStatus":
      case "milestoneStatus":
      case "projectTags":
      case "projectSector":
      case "projectLocation":
      case "projectImplementationMode":
      case "recipientMinistry":
      case "projectFlags":
      case "projectZones":
      case "districtProjectLocation":
        currentFilter = currentFilter || [];
        let filter = currentFilter.find(val => val === value.key);
        !filter
          ? currentFilter.push(value.key)
          : (currentFilter = currentFilter.filter(val => val !== value.key));
        projectListParams = {
          ...projectListParams,
          [filterName]: currentFilter
        };
        //console.log(projectListParams)
        break;

      // In this case value is boolean
      case "pmg":
      case "pragatiReview":
        currentFilter = value.checked;
        !currentFilter && delete projectListParams[filterName];
        projectListParams = !currentFilter
          ? { ...projectListParams, ...defaultListParams }
          : { ...projectListParams, [filterName]: currentFilter };
        break;

      case "projectCost":
      case "delayedProject":
      case "costOverRun":
        currentFilter = currentFilter || [];
        const { key } = value || {};
        const from = key.split("-")[0];
        const to = key.split("-")[1];
        if (isValidArray(currentFilter)) {
          const keys = value.key.split("-");

          const index = currentFilter.indexOf(value => {
            const { key } = value;
            return key.from === from && key.to === to;
          });

          index
            ? currentFilter.splice(index, 1)
            : currentFilter.push({
                from: keys[0] === "null" ? null : keys[0],
                to: keys[1] === "null" ? null : keys[1]
              });
        } else {
          currentFilter.push({
            from: from === "null" ? null : from,
            to: to === "null" ? null : to
          });
        }
        !currentFilter && delete projectListParams[filterName];
        projectListParams = !currentFilter
          ? { ...projectListParams }
          : { ...projectListParams, [filterName]: currentFilter };
        break;

      default:
        break;
    }

    return { ...projectListParams, offset: 0 };
  };

  postFilterData1 = value => {
    const projectFlagskey = value.map(item => item.key);
    this.setState({ Monitoringflagcurrent: projectFlagskey }, () => {
      this.getProjectListData({
        ...this.state.static_payload1,
        [this.state.quickfilterdatanew[0]]: this.state.Monitoringflagcurrent,
        [this.state.quickfilterdatanew[1]]: this.state.ProjectStatuscurrent,
        [this.state.quickfilterdatanew[2]]: this.state.ProjectStagecurrent,
        [this.state.quickfilterdatanew[3]]: this.state
          .ProjectSponsoringMinistrycurrent,
        [this.state.quickfilterdatanew[4]]: this.state.ProjectLocationcurrent,
        [this.state.quickfilterdatanew[5]]: this.state
          .ImplementationModecurrent,
        [this.state.quickfilterdatanew[6]]: this.state.Projectzonecurrent.map(
          e => {
            return e.key;
          }
        )
      });
    });
  };

  postFilterData1_State = value => {
    const projectFlagskey = value.map(item => item.key);
    this.setState({ Monitoringflag_State: projectFlagskey }, () => {
      this.getProjectListData({
        ...this.state.static_payload50_state,
        [this.state.quickfilterdata_state[0]]: this.state.Monitoringflag_State,
        [this.state.quickfilterdata_state[1]]: this.state.ProjectStatus_State,
        [this.state.quickfilterdata_state[2]]: this.state.ProjectStage_State,
        [this.state.quickfilterdata_state[3]]: this.state
          .ProjectSponsoringDepartment_State,
        [this.state.quickfilterdata_state[4]]: this.state.ProjectDistrict_State,
        [this.state.quickfilterdata_state[5]]: this.state
          .ImplementationModecurrent,
        [this.state.quickfilterdata_state[6]]: this.state.ProjectCost_State
      });
    });
  };
  postFilterData2_State = value => {
    const projectFlagskey = value.map(item => item.key);
    this.setState({ ProjectStatus_State: projectFlagskey }, () => {
      this.getProjectListData({
        ...this.state.static_payload50_state,
        [this.state.quickfilterdata_state[0]]: this.state.Monitoringflag_State,
        [this.state.quickfilterdata_state[1]]: this.state.ProjectStatus_State,
        [this.state.quickfilterdata_state[2]]: this.state.ProjectStage_State,
        [this.state.quickfilterdata_state[3]]: this.state
          .ProjectSponsoringDepartment_State,
        [this.state.quickfilterdata_state[4]]: this.state.ProjectDistrict_State,
        [this.state.quickfilterdata_state[5]]: this.state
          .ImplementationModecurrent,
        [this.state.quickfilterdata_state[6]]: this.state.ProjectCost_State
      });
    });
  };

  postFilterData3_State = value => {
    const projectFlagskey = value.map(item => item.key);
    this.setState({ ProjectStage_State: projectFlagskey }, () => {
      this.getProjectListData({
        ...this.state.static_payload50_state,
        [this.state.quickfilterdata_state[0]]: this.state.Monitoringflag_State,
        [this.state.quickfilterdata_state[1]]: this.state.ProjectStatus_State,
        [this.state.quickfilterdata_state[2]]: this.state.ProjectStage_State,
        [this.state.quickfilterdata_state[3]]: this.state
          .ProjectSponsoringDepartment_State,
        [this.state.quickfilterdata_state[4]]: this.state.ProjectDistrict_State,
        [this.state.quickfilterdata_state[5]]: this.state
          .ImplementationModecurrent,
        [this.state.quickfilterdata_state[6]]: this.state.ProjectCost_State
      });
    });
  };

  postFilterData4_State = value => {
    const projectFlagskey = value.map(item => item.key);
    this.setState(
      { ProjectSponsoringDepartment_State: projectFlagskey },
      () => {
        this.getProjectListData({
          ...this.state.static_payload50_state,
          [this.state.quickfilterdata_state[0]]: this.state
            .Monitoringflag_State,
          [this.state.quickfilterdata_state[1]]: this.state.ProjectStatus_State,
          [this.state.quickfilterdata_state[2]]: this.state.ProjectStage_State,
          [this.state.quickfilterdata_state[3]]: this.state
            .ProjectSponsoringDepartment_State,
          [this.state.quickfilterdata_state[4]]: this.state
            .ProjectDistrict_State,
          [this.state.quickfilterdata_state[5]]: this.state
            .ImplementationModecurrent,
          [this.state.quickfilterdata_state[6]]: this.state.ProjectCost_State
        });
      }
    );
  };
  postFilterData5_State = value => {
    const projectFlagskey = value.map(item => item.key);
    this.setState({ ProjectDistrict_State: projectFlagskey }, () => {
      this.getProjectListData({
        ...this.state.static_payload50_state,
        [this.state.quickfilterdata_state[0]]: this.state.Monitoringflag_State,
        [this.state.quickfilterdata_state[1]]: this.state.ProjectStatus_State,
        [this.state.quickfilterdata_state[2]]: this.state.ProjectStage_State,
        [this.state.quickfilterdata_state[3]]: this.state
          .ProjectSponsoringDepartment_State,
        [this.state.quickfilterdata_state[4]]: this.state.ProjectDistrict_State,
        [this.state.quickfilterdata_state[5]]: this.state
          .ImplementationModecurrent,
        [this.state.quickfilterdata_state[6]]: this.state.ProjectCost_State
      });
    });
  };

  postFilterData6_State = value => {
    const projectFlagskey = value.map(item => item.key);
    this.setState({ ImplementationModecurrent: projectFlagskey }, () => {
      this.getProjectListData({
        ...this.state.static_payload50_state,
        [this.state.quickfilterdata_state[0]]: this.state.Monitoringflag_State,
        [this.state.quickfilterdata_state[1]]: this.state.ProjectStatus_State,
        [this.state.quickfilterdata_state[2]]: this.state.ProjectStage_State,
        [this.state.quickfilterdata_state[3]]: this.state
          .ProjectSponsoringDepartment_State,
        [this.state.quickfilterdata_state[4]]: this.state.ProjectDistrict_State,
        [this.state.quickfilterdata_state[5]]: this.state
          .ImplementationModecurrent,
        [this.state.quickfilterdata_state[6]]: this.state.ProjectCost_State
      });
    });
  };
  postFilterData7_State = value => {
    const projectFlagskey = value.map(item => item.key);
    const output = projectFlagskey.map(item => {
      const [from, to] = item.split("-");
      return {
        from: from === "null" ? null : from,
        to
      };
    });
    this.setState({ ProjectCost_State: output }, () => {
      this.getProjectListData({
        ...this.state.static_payload50_state,
        [this.state.quickfilterdata_state[0]]: this.state.Monitoringflag_State,
        [this.state.quickfilterdata_state[1]]: this.state.ProjectStatus_State,
        [this.state.quickfilterdata_state[2]]: this.state.ProjectStage_State,
        [this.state.quickfilterdata_state[3]]: this.state
          .ProjectSponsoringDepartment_State,
        [this.state.quickfilterdata_state[4]]: this.state.ProjectDistrict_State,
        [this.state.quickfilterdata_state[5]]: this.state
          .ImplementationModecurrent,
        [this.state.quickfilterdata_state[6]]: this.state.ProjectCost_State
      });
    });
  };
  postFilterData2 = value => {
    const projectStatuskey = value.map(item => item.key);
    this.setState({ ProjectStatuscurrent: projectStatuskey }, () => {
      this.getProjectListData({
        ...this.state.static_payload1,
        [this.state.quickfilterdatanew[0]]: this.state.Monitoringflagcurrent,
        [this.state.quickfilterdatanew[1]]: this.state.ProjectStatuscurrent,
        [this.state.quickfilterdatanew[2]]: this.state.ProjectStagecurrent,
        [this.state.quickfilterdatanew[3]]: this.state
          .ProjectSponsoringMinistrycurrent,
        [this.state.quickfilterdatanew[4]]: this.state.ProjectLocationcurrent,
        [this.state.quickfilterdatanew[5]]: this.state
          .ImplementationModecurrent,
        [this.state.quickfilterdatanew[6]]: this.state.Projectzonecurrent.map(
          e => {
            return e.key;
          }
        )
      });
    });
  };
  postFilterData3 = value => {
    const projectStagekey = value.map(item => item.key);
    this.setState({ ProjectStagecurrent: projectStagekey }, () => {
      this.getProjectListData({
        ...this.state.static_payload1,
        [this.state.quickfilterdatanew[0]]: this.state.Monitoringflagcurrent,
        [this.state.quickfilterdatanew[1]]: this.state.ProjectStatuscurrent,
        [this.state.quickfilterdatanew[2]]: this.state.ProjectStagecurrent,
        [this.state.quickfilterdatanew[3]]: this.state
          .ProjectSponsoringMinistrycurrent,
        [this.state.quickfilterdatanew[4]]: this.state.ProjectLocationcurrent,
        [this.state.quickfilterdatanew[5]]: this.state
          .ImplementationModecurrent,
        [this.state.quickfilterdatanew[6]]: this.state.Projectzonecurrent.map(
          e => {
            return e.key;
          }
        )
      });
    });
  };
  postFilterData4 = value => {
    const projectSponsoringMinistrykey = value.map(item => item.key);
    this.setState(
      { ProjectSponsoringMinistrycurrent: projectSponsoringMinistrykey },
      () => {
        this.getProjectListData({
          ...this.state.static_payload1,
          [this.state.quickfilterdatanew[0]]: this.state.Monitoringflagcurrent,
          [this.state.quickfilterdatanew[1]]: this.state.ProjectStatuscurrent,
          [this.state.quickfilterdatanew[2]]: this.state.ProjectStagecurrent,
          [this.state.quickfilterdatanew[3]]: this.state
            .ProjectSponsoringMinistrycurrent,
          [this.state.quickfilterdatanew[4]]: this.state.ProjectLocationcurrent,
          [this.state.quickfilterdatanew[5]]: this.state
            .ImplementationModecurrent,
          [this.state.quickfilterdatanew[6]]: this.state.Projectzonecurrent.map(
            e => {
              return e.key;
            }
          )
        });
      }
    );
  };
  postFilterData5 = value => {
    const projectLocationkey = value.map(item => item.key);
    this.setState({ ProjectLocationcurrent: projectLocationkey }, () => {
      this.getProjectListData({
        ...this.state.static_payload1,
        [this.state.quickfilterdatanew[0]]: this.state.Monitoringflagcurrent,
        [this.state.quickfilterdatanew[1]]: this.state.ProjectStatuscurrent,
        [this.state.quickfilterdatanew[2]]: this.state.ProjectStagecurrent,
        [this.state.quickfilterdatanew[3]]: this.state
          .ProjectSponsoringMinistrycurrent,
        [this.state.quickfilterdatanew[4]]: this.state.ProjectLocationcurrent,
        [this.state.quickfilterdatanew[5]]: this.state
          .ImplementationModecurrent,
        [this.state.quickfilterdatanew[6]]: this.state.Projectzonecurrent.map(
          e => {
            return e.key;
          }
        )
      });
    });
  };
  postFilterData6 = value => {
    const implementationModekey = value.map(item => item.key);
    this.setState({ ImplementationModecurrent: implementationModekey }, () => {
      this.getProjectListData({
        ...this.state.static_payload1,
        [this.state.quickfilterdatanew[0]]: this.state.Monitoringflagcurrent,
        [this.state.quickfilterdatanew[1]]: this.state.ProjectStatuscurrent,
        [this.state.quickfilterdatanew[2]]: this.state.ProjectStagecurrent,
        [this.state.quickfilterdatanew[3]]: this.state
          .ProjectSponsoringMinistrycurrent,
        [this.state.quickfilterdatanew[4]]: this.state.ProjectLocationcurrent,
        [this.state.quickfilterdatanew[5]]: this.state
          .ImplementationModecurrent,
        [this.state.quickfilterdatanew[6]]: this.state.Projectzonecurrent.map(
          e => {
            return e.key;
          }
        )
      });
    });
  };
  postFilterData7 = value => {
    console.log(value);
    const projectzonekeys = value.map(item => item.key);
    console.log(projectzonekeys);
    this.setState({ Projectzonecurrent: value }, () => {
      this.getProjectListData({
        ...this.state.static_payload1,
        [this.state.quickfilterdatanew[0]]: this.state.Monitoringflagcurrent,
        [this.state.quickfilterdatanew[1]]: this.state.ProjectStatuscurrent,
        [this.state.quickfilterdatanew[2]]: this.state.ProjectStagecurrent,
        [this.state.quickfilterdatanew[3]]: this.state
          .ProjectSponsoringMinistrycurrent,
        [this.state.quickfilterdatanew[4]]: this.state.ProjectLocationcurrent,
        [this.state.quickfilterdatanew[5]]: this.state
          .ImplementationModecurrent,
        [this.state.quickfilterdatanew[6]]: projectzonekeys
      });
    });
  };
  closeAddIssueModal = () => {
    this.setState({ isAddIssueModalVisible: false });
  };

  addProjectIssues = selectedProjectIssues => {
    const { submitHandler } = this.props;
    this.setState({ isAddIssueModalVisible: false });
    submitHandler(selectedProjectIssues);
  };

  addIssuesToAgenda = selectedIssues => {
    this.setState(prevState => {
      const issuesArr = [];
      const oldIssues = [...prevState.selectedIssues];
      selectedIssues.forEach(currentIssue => {
        let isIssueExist = false;
        oldIssues.forEach((oldIssue, index) => {
          if (currentIssue.id === oldIssue.id) {
            isIssueExist = true;
          }
        });
        if (!isIssueExist) {
          issuesArr.push(currentIssue);
        }
      });

      return {
        isAddIssueModalVisible: false,
        selectedIssues: [].concat(oldIssues, issuesArr),
        dataUnsaved: true
      };
    });
  };

  resetSelectedIssues = () => {
    this.setState({
      selectedIssues: []
    });
  };

  onProjectAwardedByChange = e => {
    this.setState(
      {
        projectAwardedBy: e.target.checked,
        projectListParams: { ...defaultListParams },
        filterArrayName: [],
        bubbleFilters: []
      },
      () => {
        this.getProjectListData({
          ...{
            groupCategory: this.getGroupCategory()
          }
        });
      }
    );
  };

  render() {
    const {
      props: { show, closeModal, closeIssueModal, selectedProjects },
      state: {
        loadedProjects,
        projectDTO,
        projectListApiStatus,
        isLoadingOnScroll,
        selectAll,
        selectedFilter,
        filtersData,
        clearAll,
        projectListParams,
        filterArrayName,
        projectAwardedBy,
        //projectsList,
        projectListOnSelection,
        newProjectList,
        selectedIssues,
        deletedIssued,
        isAddIssueModalVisible,
        activeProjects,
        selectedProjectIds,
        addInAgendaDisable,
        disableAddIssueModal
      }
    } = this;

    const filters = loadedProjects[0] ? loadedProjects[0]["filters"] : {};

    const { total } = loadedProjects[0] || {};
    let projectsList = [];
    console.log(projectsList, projectsList.length);
    Object.keys(loadedProjects).forEach(key => {
      projectsList = [...projectsList, ...loadedProjects[key]["listDTO"]];
    });
    let count;
    if (isValidArray(selectedProjects) && selectedProjects.length > 0) {
      count = selectedProjects.length;
    } else {
      count = 0;
    }

    // make all projects active if select all is active
    isValidArray(projectsList) &&
      projectsList.forEach(project => {
        selectAll && (project.isSelected = true);
        project.isSelected && count++;
      });

    //changes after merge start
    if (selectAll) {
      selectedProjects.forEach(selectedProjectItem => {
        if (
          projectsList.some(project => project.id === selectedProjectItem.id)
        ) {
          count--;
          //console.log("check here count", selectedProjectItem);
        }
      });
    }
    return (
      <React.Fragment>
        <LoaderPage
          loading={
            isLoadingOnScroll === STATUS.LOADING ||
            projectListApiStatus === STATUS.LOADING
          }
        />
        <Modal
          show={show}
          dialogClassName="modal-select-issue modal-select-project agenda-select-issue"
          onHide={closeModal}
        >
          <Modal.Header closeButton>
            <Modal.Title>
              Select Project(s){" "}
              {(total && <span className="totalCount">({total})</span>) || null}
            </Modal.Title>
          </Modal.Header>
          <LoadListOnScroll offset={projectListParams.offset}>
            <Modal.Body className="scroll">
              <div
                className="issue-list-content agenda-project-list-content"
                ref={elem => {
                  this.modalWrapper = elem;
                }}
              >
                <div className="issue-list-filter-wrapper agenda-field">
                  <Form>
                    <ToggleBtn
                      checked={projectAwardedBy}
                      callback={this.onProjectAwardedByChange}
                      id="projectToggle"
                    />
                    <div className="issue-list-filters">
                      <div className="filter-header">
                        <div className="filter-title">
                          <Image src={IconFilter} alt="Filter Icon" />
                          <span>Filters</span>
                        </div>
                        {this.state.projectAwardedBy ? (
                          <>
                            <AgendaStateProjectQF
                              filtersValue={projectListParams}
                              filterData={filtersData}
                              staticFilterData={
                                this.state.state_static_filter_data
                              }
                              onChange1={this.postFilterData1_State}
                              onChange2={this.postFilterData2_State}
                              onChange3={this.postFilterData3_State}
                              onChange4={this.postFilterData4_State}
                              onChange5={this.postFilterData5_State}
                              onChange6={this.postFilterData6_State}
                              onChange7={this.postFilterData7_State}
                              onFilterChange={this.handleFilterChange}
                              onCloseChange={this.handleCloseChange}
                              checkedData={this.state.bubbleFilters}
                              Projectstageandstatusdisplay={true}
                            />
                            {/* {isValidArray(filterArrayName) ? (
                              <div
                                className="clear-filter"
                                onClick={this.clearAll}
                              >
                                Clear All
                              </div>
                            ) : null} */}
                          </>
                        ) : (
                          <>
                            <ProjectQuickFilter
                              filtersValue={projectListParams}
                              filterData={filtersData}
                              staticFilterData={this.state.staticfilterdata}
                              onChange1={this.postFilterData1}
                              onChange2={this.postFilterData2}
                              onChange3={this.postFilterData3}
                              onChange4={this.postFilterData4}
                              onChange5={this.postFilterData5}
                              onChange6={this.postFilterData6}
                              onChange7={this.postFilterData7}
                              onFilterChange={this.handleFilterChange}
                              onCloseChange={this.handleCloseChange}
                              checkedData={this.state.bubbleFilters}
                              Projectstageandstatusdisplay={true}
                            />
                          </>
                        )}
                      </div>
                      {projectListApiStatus === STATUS.LOADING ? (
                        <LoaderTemplate
                          parentClass={"filter-loader-project-list"}
                          children={<FilterLoader />}
                          height={300}
                          width={400}
                        />
                      ) : (
                        <FilterComponent
                          //clearAll={clearAll}
                          selectedFilters={selectedFilter}
                          filterData={filtersData}
                          filtersValue={projectListParams}
                          onChange={this.handleCheckbox}
                        />
                      )}
                    </div>
                  </Form>
                </div>
                <div className="issue-list-multiple">
                  <div className="select-all">
                    <Form.Group>
                      <Form.Check
                        className={`form-checkbox ${
                          selectAll ? "checked" : ""
                        }`}
                      >
                        <Form.Check.Input
                          type="checkbox"
                          name="select-issue"
                          value={selectAll}
                        />
                        <Form.Check.Label onClick={this.toggleSelectAll} />
                        <span>Select All</span>
                      </Form.Check>
                    </Form.Group>
                  </div>
                  <ProjectSearchSorting
                    params={projectListParams}
                    sortBy={sortByArr}
                    //defaultDates={dateFilter}
                    callApiOnSuccess={params => {
                      //this.getProjectListData({ ...params, offset: 0 });
                      this.setState(
                        {
                          loadedProjects: {}
                        },
                        () => {
                          this.getProjectListData({ ...params, offset: 0 });
                        }
                      );
                    }}
                  />
                  <div className="applied-filter-list">
                    {this.state.bubbleFilters.length == 0 ? null : (
                      <>
                        {this.state.bubbleFilters.map((element, index) => (
                          <div className="applied-filter" key={index}>
                            {element.displayName}
                            <span
                              className="close"
                              onClick={e => {
                                this.handleCheckbox1(
                                  element,
                                  element.filterName
                                );
                              }}
                            >
                              X
                            </span>
                          </div>
                        ))}
                      </>
                    )}
                    {this.state.bubbleFilters.length > 1 ? (
                      <div className="clear-filter-new" onClick={this.clearAll}>
                        Clear All
                      </div>
                    ) : null}
                  </div>
                  <div className="select-issue-list-wrapper">
                    <SelectProjectWithLoader
                      projects={projectsList}
                      isLoading={projectListApiStatus}
                      selectionHandler={this.selectionHandler}
                      ProjectSelected="checkbox"
                      selectedProjects={selectedProjects}
                    />

                    {total !== projectsList.length ? (
                      <Button
                        className="load-more-issue-btn"
                        onClick={this.onLoadMore}
                      >
                        Load More
                      </Button>
                    ) : null}
                  </div>
                </div>
              </div>
            </Modal.Body>
          </LoadListOnScroll>

          <Modal.Footer className="sticky-footer">
            <div className="selected-projects">
              Selected Projects: <span>{count || 0}</span>
            </div>
            {disableAddIssueModal ? (
              <TooltipCustom text="Select one or more Projects to proceed">
                <Button
                  className="btn-orange no-padding btn-select-issues"
                  onClick={this.submitHandler}
                  disabled={disableAddIssueModal}
                >
                  Select Issues
                </Button>
              </TooltipCustom>
            ) : (
              <Button
                className="btn-orange no-padding btn-select-issues"
                onClick={this.submitHandler}
                disabled={disableAddIssueModal}
              >
                Select Issues
              </Button>
            )}

            <Button
              className="btn-orange-invert no-padding btn-cancel"
              onClick={closeModal}
            >
              Cancel
            </Button>
          </Modal.Footer>
        </Modal>
        <DisplayByPermission display={isAddIssueModalVisible}>
          <SelectIssue
            show={isAddIssueModalVisible}
            closeModal={this.closeAddIssueModal}
            closeProjectModal={closeModal}
            selectedProjects={activeProjects}
            selectedIssues={this.props.selectedIssues}
            submitHandler={this.addProjectIssues}
            deletedIssued={deletedIssued}
            addInAgendaDisable={addInAgendaDisable}
            resetSelectedIssues={this.resetSelectedIssues}
            projectAwardedBy={projectAwardedBy}
          />
        </DisplayByPermission>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  const {
    commonReducer: { projectList, status },
    donwloadExcelReducer: { projectListDownload },
    dashboardReducer: { notificationData, notifyStatusUpdateData },
    projectListReducer
  } = state;
  return {
    projectListDownload,
    projectList,
    status,
    notificationData,
    notifyStatusUpdateData,
    projectListReducer
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      //getDownloadProjectListAction,
      //clearProjectListDownloadAction,
      // GET_PROJECT_LIST_ACTION,
      //CLEAR_ISSUE_OLD_FILTERS_ACTION,
      //getDraftedProjectDetails,
      // getDashboardNotifications,
      //getNotificationUpdates
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PermissionHOC(ProjectListHoc(SelectProject)));
